import React from 'react';
import {Helmet} from 'react-helmet-async';
import {t} from '@lingui/core/macro';

import {MainLayout} from 'widgets/layout';
import {Dashboard, useDashboard, useHomeState} from 'widgets/dashboard';
import {Landing} from 'widgets/landing';
import {useEmailStatusRedirects} from 'entities/user';

const HomePage: React.FC = () => {
    const titleText = t`Обзор мониторов и инцидентов | Overseer`;
    const dashboard = useDashboard();
    const {isLanding} = useHomeState();
    useEmailStatusRedirects();

    return (
        <MainLayout isPlugMode={isLanding}>
            <Helmet>
                <title>
                    {titleText}
                </title>
            </Helmet>
            {isLanding ? <Landing/> : <Dashboard {...dashboard}/>}
        </MainLayout>
    );
};

export default HomePage;
